import React, { useState } from "react";
import { toast } from 'react-toastify';
import * as api from "../api";
import QrCodeDownloadModal from "../components/QrCodeDownloadModal";

function CreateQrCodePage() {
  const [collectionName, setCollectionName] = useState("");
  const [pageTitle, setPageTitle] = useState("");
  const [files, setFiles] = useState(null);
  const [qrColor, setQrColor] = useState("#000000");
  const [headerColor, setHeaderColor] = useState("#FFFFFF");
  const [createdQr, setCreatedQr] = useState(null);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("collection_name", collectionName);
    formData.append("page_title", pageTitle || collectionName);
    formData.append("qr_color", qrColor);
    formData.append("header_color", headerColor);

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append("files[]", files[i]);
      }
    }

    try {
      const response = await api.createCollection(formData);
      toast.success("Coleção criada com sucesso!");

      setCreatedQr({
        collection_id: response.data.collection_id,
        collection_name: collectionName,
        qr_color: qrColor,
      });
      setIsDownloadModalOpen(true);

    //Limpar o formulário após o sucesso para facilitar a criação de uma nova coleção.
    setCollectionName("");
    setPageTitle("");
    setFiles(null);
    e.target.reset(); // Limpa o input de arquivos
    } catch (err) {
      console.error("Erro ao criar coleção:", err);
      const errorMessage = err.response?.data?.error || "Não foi possível criar a coleção.";
      toast.error(errorMessage); // <-- SUBSTITUÍDO
    }
  };

  const handleCloseDownloadModal = () => {
    setIsDownloadModalOpen(false);
    setCreatedQr(null);
  };

  return (
    <div>
      <h1 className="text-4xl font-bold text-gray-800 mb-8">Criar Nova Coleção de QR Code</h1>
      <div className="bg-white p-8 rounded-xl shadow-md">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <label htmlFor="collection_name" className="block text-sm font-medium text-gray-700 mb-1">
                Nome da Coleção (para organização)
              </label>
              <input
                type="text"
                id="collection_name"
                value={collectionName}
                onChange={(e) => setCollectionName(e.target.value)}
                className="w-full bg-gray-50 border border-gray-300 rounded-lg p-3"
                required
              />
            </div>
            <div>
              <label htmlFor="page_title" className="block text-sm font-medium text-gray-700 mb-1">
                Título da Página (o que aparece no topo)
              </label>
              <input
                type="text"
                id="page_title"
                value={pageTitle}
                onChange={(e) => setPageTitle(e.target.value)}
                className="w-full bg-gray-50 border border-gray-300 rounded-lg p-3"
                placeholder="Opcional, usa o nome da coleção se vazio"
              />
            </div>
          </div>
          <div>
            <label htmlFor="files" className="block text-sm font-medium text-gray-700 mb-1">
              Selecione os PDFs
            </label>
            <input
              type="file"
              id="files"
              onChange={(e) => setFiles(e.target.files)}
              className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              multiple
              required
              accept="application/pdf"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="qr_color_text" className="block text-sm font-medium text-gray-700 mb-1">
                Cor QR Code
              </label>
              <div className="flex items-center border border-gray-300 rounded-lg">
                <input
                  type="text"
                  value={qrColor}
                  onChange={(e) => setQrColor(e.target.value)}
                  className="w-full p-3 bg-gray-50 border-0 rounded-l-md"
                />
                <input
                  type="color"
                  value={qrColor}
                  onChange={(e) => setQrColor(e.target.value)}
                  className="h-12 w-14 p-1 bg-gray-50 rounded-r-lg cursor-pointer"
                />
              </div>
            </div>
            <div>
              <label htmlFor="header_color_text" className="block text-sm font-medium text-gray-700 mb-1">
                Cor Cabeçalho
              </label>
              <div className="flex items-center border border-gray-300 rounded-lg">
                <input
                  type="text"
                  value={headerColor}
                  onChange={(e) => setHeaderColor(e.target.value)}
                  className="w-full p-3 bg-gray-50 border-0 rounded-l-md"
                />
                <input
                  type="color"
                  value={headerColor}
                  onChange={(e) => setHeaderColor(e.target.value)}
                  className="h-12 w-14 p-1 bg-gray-50 rounded-r-lg cursor-pointer"
                />
              </div>
            </div>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition duration-300 shadow-sm"
          >
            Fazer Upload e Gerar QR Code
          </button>
        </form>
      </div>

      {isDownloadModalOpen && createdQr && (
        <QrCodeDownloadModal
          collectionId={createdQr.collection_id}
          collectionName={createdQr.collection_name}
          qrColor={createdQr.qr_color}
          onClose={handleCloseDownloadModal}
        />
      )}
    </div>
  );
}

export default CreateQrCodePage;